import { Alert } from '@mm/components';
import { landmineNames } from '@mm/constants/landmine-names';
import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import React from 'react';
import { PrimaryButton } from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import CollapsibleContentContainer from '../../../../common/components/CollapsibleContentContainer/CollapsibleContentContainer';
import { InputWithClipboard } from '../common/InputWithClipboard/InputWithClipboard';
import { useApiKeys } from '../common/use-api-keys';
import './MobileMonkeyApi.pcss';

export const MobileMonkeyApi = () => {
  const modalActions = useModalActions();
  const { apiKeysByType, apiKey, regenerateKey, isUpgradeRequired } =
    useApiKeys('Zapier', 'Customers.ai API Key', {
      headerText: '\u26a0 Regenerate Customers.ai API Key',
      okButtonText: 'Regenerate Key',
      messageText: (
        <>
          <p>All API requests using this key will need to be updated.</p>
          <p>This step cannot be undone.</p>
        </>
      ),
    });

  const computedApiKey = isUpgradeRequired
    ? 'Upgrade to unlock this feature!'
    : (apiKey && apiKey.authToken) || '';

  const openUpgradeModal = (isNoLongerAvailable = false) => {
    const landmineName = isNoLongerAvailable
      ? `${landmineNames.FEATURE_NO_LONGER_AVAILABLE}_${landmineNames.INTEGRATIONS_MM_API}`
      : landmineNames.INTEGRATIONS_MM_API;
    modalActions.openUniversalUpgradeLandmineModal({
      landmineName,
      planFallback: PageBillingType.ProUnicorn,
    });
  };

  const onFocus = () => {
    if (isUpgradeRequired) {
      openUpgradeModal();
    }
  };

  const regenerateButton = (
    <PrimaryButton onClick={regenerateKey} disabled={isUpgradeRequired}>
      Regenerate Key
    </PrimaryButton>
  );

  const isUpgradeAlertNeeded = isUpgradeRequired && !!apiKeysByType.length;

  return (
    <section>
      {isUpgradeAlertNeeded && (
        <Alert className="mobile-monkey-api__alert" showCloseIcon={false}>
          You no longer have access to this Startup feature. To continue using
          Customers.ai API,{' '}
          <span
            className="mobile-monkey-api__alert-link"
            onClick={() => openUpgradeModal(true)}
          >
            Upgrade to Startup
          </span>
        </Alert>
      )}

      <div className="mobile-monkey-api-regenerate-button-container">
        {regenerateButton}
      </div>

      <CollapsibleContentContainer
        className="mobile-monkey-api-collapisble-container"
        orderNumber="1"
        containerName="Copy your API Key"
      >
        <InputWithClipboard
          title="API Key"
          helperText="Copy this key to your clipboard!"
          isCopyDisabled={isUpgradeRequired}
          value={computedApiKey}
          onFocus={onFocus}
        />
      </CollapsibleContentContainer>
      <CollapsibleContentContainer
        orderNumber="2"
        containerName="API Docs"
        className="mobile-monkey-api-collapisble-container"
      >
        <p className="mobile-monkey-api__docs-container">
          Check out the API Docs{' '}
          <a
            className="mobile-monkey-api__docs-link"
            target="_blank"
            href="https://api.mobilemonkey.com/swagger/"
          >
            here
          </a>
        </p>
      </CollapsibleContentContainer>
    </section>
  );
};
